import mixpanel, { Mixpanel } from 'mixpanel-browser';
import React from 'react';

export const MixpanelContext = React.createContext<Mixpanel>(mixpanel);
